export const errors = {
  REQUEST_REJECTED: 'Request rejected',
};

export const keplrConstants = {
  errors,
};
